import { Box, Flex, Button, IconButton, Dialog, DialogContentContainer } from '@vibe/core';
import { shift } from '@floating-ui/react-dom';
import { Emoji } from '@vibe/icons';

type EmojiPickerProps = {
  isAddingReply?: boolean;
  replyDraft?: string;
  setReplyDraft?: (value: string) => void;

  isAddingComment?: boolean;
  commentDraft?: string;
  setCommentDraft?: (value: string) => void;

  showEmojis: boolean;
  setShowEmojis: (value: boolean) => void;

  dialogOffsetX?: number;
  dialogOffsetY?: number;
};

const EMOJIS = [
  ['🙂', '😂', '🥺', '👍', '👎', '🙏'],
  ['👀', '🎉', '🔥', '❤️', '⚠️', '✅'],
];

function EmojiPicker({
  isAddingReply,
  replyDraft,
  setReplyDraft,
  isAddingComment,
  commentDraft,
  setCommentDraft,
  showEmojis,
  setShowEmojis,
  dialogOffsetX,
  dialogOffsetY,
}: EmojiPickerProps) {
  return (
    <Dialog
      content={
        <DialogContentContainer
          size="none"
          style={{
            overflow: 'hidden',
          }}
        >
          <Box padding="small" backgroundColor="primaryBackgroundColor">
            {EMOJIS.map((row, rowIdx) => (
              <Flex key={rowIdx}>
                {row.map((emoji) => (
                  <Button
                    key={emoji}
                    kind="tertiary"
                    size="small"
                    onClick={() => {
                      if (setReplyDraft) {
                        setReplyDraft((replyDraft || '') + emoji);
                      }
                      if (setCommentDraft) {
                        setCommentDraft((commentDraft || '') + emoji);
                      }
                      setShowEmojis(false);
                    }}
                  >
                    {emoji}
                  </Button>
                ))}
              </Flex>
            ))}
          </Box>
        </DialogContentContainer>
      }
      middleware={[shift({ mainAxis: false })]}
      showTrigger={[]}
      hideWhenReferenceHidden
      open={showEmojis}
      instantShowAndHide
      tooltip
      moveBy={{
        main: dialogOffsetY ? dialogOffsetY : 0,
        secondary: dialogOffsetX ? dialogOffsetX : 0,
      }}
      // @ts-ignore
      position="top-start"
      onClickOutside={() => {
        setShowEmojis(false);
      }}
    >
      <IconButton
        icon={Emoji}
        kind="secondary"
        active={showEmojis}
        size="medium"
        color="primary"
        disabled={isAddingReply || isAddingComment}
        onClick={() => {
          setShowEmojis(!showEmojis);
        }}
      />
    </Dialog>
  );
}

export default EmojiPicker;
